import { store } from "../store";
import * as HelperSrc from "../HelperSrc";
import { lang } from "../lang";
import * as Instance from "../Instance";
import * as ModelHelperSrc from "../model/HelperSrc";

async function processFile(filename: string, workbook: string): Promise<void> {
    HelperSrc.setLastActivity();

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/client/${store.db || ""}/workbook/${workbook}/upload/process_file/`,
            {
                headers: { "Content-Type": "application/json" }
            },
            { file_name: filename }
        )
        .then((response) => {
            if (response.data.message.error) {
                store.doNotice(lang[response.data.message.error]);
            }
        });
}

export { processFile };
